'use client';

import cn from "classnames";
import Icon from "../Icon";
import { IconName } from "../Icon/Icon.registry";
import { TEXT_VARIANTS } from "../Text";
export type SectionButtonProps = {
  title: string;
  isActive: boolean;
  onClick: () => void;
  iconName: IconName;
}

const SectionButton = ({
  title,
  iconName,
  isActive,
  onClick,
}: SectionButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        TEXT_VARIANTS["p2"],
        "flex gap-2xs py-xs pl-s items-center",
        "transition-all duration-400 ease-appear focus-visible:button-focus hover:button-text-tab-active",
        isActive ? "button-text-tab-active font-weight-medium" : "button-text-tab font-weight-regular"
      )}
    >
      <Icon name={iconName} size={20} type="outlined" />
      {title}
    </button>

  )
}

export default SectionButton;
